module.exports = __webpack_public_path__ + "img/logoArty.465408a3.svg";